import axiosInstance from "../config/axiosInterceptor";

export async function getWebUsers() {
  const response = await axiosInstance.get("/api/WebUser");
  return response?.data || response || [];
}

export async function getWebUserById(id) {
  const response = await axiosInstance.get(`/api/WebUser/${id}`);
  return response?.data || response;
}

export async function getWebUserByEmail(email) {
  const response = await axiosInstance.get(`/api/WebUser/GetByEmail/${email}`);
  return response?.data || response;
}

export async function isUserExistByEmail(email) {
  const response = await axiosInstance.get(`/api/WebUser/IsUserExistEmail/${email}`);
  return response?.data || response;
}

export async function createWebUser(userData) {
  const response = await axiosInstance.post("/api/WebUser", userData);
  return response;
}

export async function updateWebUser(userData) {
  const response = await axiosInstance.put("/api/WebUser", userData);
  return response;
}

export async function resetUserPassword(id, password) {
  const response = await axiosInstance.post(
    `/api/WebUser/ResetPassword/${id}`,
    { value: password }
  );
  // API returns { returnCode, data, exMessage }
  return response;
}

export async function resetUserPasswordByEmail(email, password) {
  // First get user by email
  const userResponse = await getWebUserByEmail(email);

  if (!userResponse || !userResponse.id) {
    throw new Error("User not found with this email");
  }

  // Then reset password using the user ID
  const resetResponse = await resetUserPassword(userResponse.id, password);

  return {
    user: userResponse,
    resetResult: resetResponse
  };
}

export async function deleteWebUser(userId) {
  const response = await axiosInstance.delete(`/api/WebUser/${userId}`);
  return response;
}

export async function getAdmins() {
  const response = await axiosInstance.get("/api/WebUser/GetAdmins");
  return response?.data || response || [];
}

export async function createAdmin(data) {
  const response = await axiosInstance.post("/api/WebUser/CreateAdmin", data);
  return response;
}

export async function inviteUser(data) {
  const response = await axiosInstance.post("/api/WebUser/InviteUser", data);
  return response;
}
